const carStaticsData = [
  {
    name: "7 AM",
    week: 4000,
    prevWeek: 2400,
  },
  {
    name: "9 AM",
    week: 3000,
    prevWeek: 1398,
  },
  {
    name: "11 AM",
    week: 2000,
    prevWeek: 9800,
  },
  {
    name: "1 PM",
    week: 2780,
    prevWeek: 3908,
  },
  {
    name: "3 PM",
    week: 1890,
    prevWeek: 4800,
  },
  {
    name: "5 PM",
    week: 2390,
    prevWeek: 3800,
  },
  {
    name: "7 PM",
    week: 3490,
    prevWeek: 4300,
  },
  {
    name: "9 PM",
    week: 3500,
    prevWeek: 4100,
  },
];

export default carStaticsData;
